import React from 'react';

import { PlaceholderItem } from 'app/components/PlaceholderItem';
import { PageContentWrapper } from 'app/components/PageContentWrapper';
import { TravelCalculationViewContentPlaceholderProps } from './TravelCalculationViewContentPlaceholder.interfaces';
import { useStyles } from './TravelCalculationViewContentPlaceholder.styles';
import { FormPlaceholder } from 'app/components/FormPlaceholder';

const TravelCalculationViewContentPlaceholder = (
  props: TravelCalculationViewContentPlaceholderProps
) => {
  const classes = useStyles();

  const { showLoadingAnimation } = props;

  return (
    <PageContentWrapper
      newAmbassadorStyle
      mainContent={
        <div className={classes.formPlaceholder}>
          <FormPlaceholder showLoadingAnimation={showLoadingAnimation} />
        </div>
      }
      sidebar={
        <PlaceholderItem
          classes={{ root: classes.sidebar }}
          rows={3}
          showLoadingAnimation={showLoadingAnimation}
        />
      }
      className={classes.pageContentWrapper}
    />
  );
};

export default TravelCalculationViewContentPlaceholder;
